
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeadingNUpProposal as ObiHeadingNUpProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heading-n-up-proposal.js';
 
 
 

 
 export const ObiHeadingNUpProposal = createComponent({
   react: React,
   tagName: 'obi-heading-n-up-proposal',
   elementClass: ObiHeadingNUpProposalElement,
   events: {
     
   }
  });
 
 